const loadGoogleMapsApi = require('load-google-maps-api')

class Map {
    constructor(eve) {
        this.event = eve
        this.lat,this.lng = eve.lat,eve.lng
        if (!eve.lat || !eve.lng) return
        var that = this

        loadGoogleMapsApi({'key': window.googleApiPublicKey}).then(function (googleMaps) {
            eve.mapExpanded = false
            eve.mapCoords = new googleMaps.LatLng(eve.lat, eve.lng);
            eve.mapStyles = [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }];

            eve.map = new googleMaps.Map(document.getElementById("event-map-canvas"), {
                center: eve.mapCoords,
                draggable: false,
                mapTypeControl: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 15,
                maxZoom: 15,
                panControl: false,
                scaleControl: false,
                scrollwheel: true,
                streetViewControl: false,
                styles: eve.mapStyles,
                zoom: 15,
                zoomControl: false
            });

            eve.map.panBy(0, -15);

            var marker = new googleMaps.Marker({
                map: eve.map,
                draggable: false,
                position: eve.mapCoords
            });

            $('.jump-to-map').click(function() {
                var wasExpanded = that.mapExpanded;

                that.expand();
                $('html, body').animate({
                    scrollTop: $('section.summary').offset().top + $('section.summary').outerHeight() - $(window).height() + (wasExpanded ? 20 : 220)
                }, { duration: 200, queue: false });

                return false;
            });

            $('#expand-map').click(function() {
                that.expand();
                return false;
            });

            $('#collapse-map').click(function() {
                that.collapse();
                return false;
            });
        }).catch(function (error) {
          console.error(error)
        })
    }

    expand() {
        if(this.event.mapExpanded) return;

        var that = this;
        this.event.mapExpanded = true;

        $('#map-text').css('display', 'block');
        $('#event-map-canvas').height(300);
        $('#expand-map').css('display', 'none');

        this.event.map.setOptions({
            draggable: true,
            minZoom: 10,
            maxZoom: 18,
            zoomControl: true
        });

        setTimeout(function() {
            google.maps.event.trigger(that.map, 'resize');
            that.event.map.setCenter(that.mapCoords);
        }, 210);
    }

    collapse() {
        if(!this.event.mapExpanded) return;

        var that = this;
        this.event.mapExpanded = false;

        $('#map-text').css('display', 'none');
        $('#event-map-canvas').height(100);
        $('#expand-map').css('display', 'block');

        this.event.map.setOptions({
            draggable: false,
            minZoom: 15,
            maxZoom: 15,
            zoom: 15,
            zoomControl: false
        });

        setTimeout(function() {
            google.maps.event.trigger(that.map, 'resize');
            that.event.map.setCenter(that.mapCoords);
            that.event.map.panBy(0, -15);
        }, 210);
    }

    initNowMap() {
        var that = this;

        $('.center').each(function() {
            var parent = $(this.event).parent();

            if (!parent.hasClass('navbar') && !parent.hasClass('events-request')) {
                that.mainContent = $(this.event);
                return false;
            }
        });

        (($('.branding-container').length) ? $('.branding-container') : that.mainContent).prepend('<div class="content-overlay hide"></div>');

        that.mainContentOverlay = $('div.content-overlay');
        that.mainContentOverlay.click(function() { that.close(); });
        that.mainContentOverlay.mouseover(function() { that.overlayMouseoverHandler(); });
        that.mainContentOverlay.mouseout(function()  { that.overlayMouseoutHandler(); });

        that.nowButton.click(function() {
            if (that.locked) return;

            if (that.mapLoaded) {
                open();
            } else {
                that._lock();

                that.map = new eved.Map({
                    canvas: $('#now-map'),
                    data: '/events/now/',
                    latitude: that.lat,
                    longitude: that.lng,
                    mapOptions: {
                        currentPosition: true,
                        scroll: true,
                        zoom: 13
                    }
                });

                that.map.loadData(function(data) {
                    window.setTimeout(function() {
                        that.map.render();
                        that.mapLoaded = true;
                        that._unlock();
                    }, 600);
                });

                open();
            }
        });

        $('section.navbar').find('a.close-map').click(function() {
            close();
            return false;
        });
    }

    open(e) {
        var that = this.event;

        if (!that.mapOpened) {
            var delay = 0;

            if ($(window).scrollTop() > 0) {
                delay = 500;
                $('html, body').animate({ scrollTop : 0 }, { duration : 400, queue : false });
            }

            if ($('section.feedback')[0] && $('section.feedback').hasClass('active')) {
                delay = 500;
                this.event.toggleFeedbackForm();
            }

            if (window.yard && window.yard.eventsRequestBox) {
                window.setTimeout(function() {
                    window.yard.toggleEventsRequestBox();
                }, delay);

                delay += 300;
            }

            if (window.cookiePolicyOverlayInstance.shown) {
                window.cookiePolicyOverlayInstance.hide();
                this.event.showCookiePolicyOverlayAfterClosingNow = true;
            }

            window.setTimeout(function() {
                that.mapHeight = $(window).height() - 75;
                that.mapOpened = true;
                that.disablePageScrolling();

                if (that.navShadowElement.is('header')) {
                    that.navShadowElement.addClass('absolute');
                }

                $('div.map-wrapper').addClass('normal-transitions').height(that.mapHeight);
                $('div.container').addClass('normal-transitions').css('paddingTop', 55 + that.mapHeight);

                $("#now-map").height(that.mapHeight - 80);

                $('section.navbar').find('.logo, form, nav').css('display', 'none');
                $('section.navbar').find('.close-map-tip').css('display', 'block');

                that.mainContent.fadeTo(100, 0.2);
                that.mainContentOverlay.removeClass('hide');

                $('section.feedback').find('a.toggle').css('left', '0px');

                $(window).bind('resize', function() {
                    that.mapResizeHandler();
                });

                window.setTimeout(function() {
                    google.maps.event.trigger(that.map.map, 'resize');
                    google.maps.event.trigger(that.map.map, 'projection_changed');
                    google.maps.event.trigger(that.map.map, 'bounds_changed');
                    google.maps.event.trigger(that.map.map, 'center_changed');
                }, 1250);
            }, delay);
        }
    }

    close(e) {
        var that = this.event;

        if (this.event.mapOpened) {
            this.event.mapOpened = false;
            this.event.enablePageScrolling();

            $('div.map-wrapper').removeClass('fast-transitions').height(0);
            $('div.container').removeClass('fast-transitions').css('paddingTop', 70);

            $('section.navbar').find('.logo, form, nav').css('display', 'block');
            $('section.navbar').find('.close-map-tip').css('display', 'none');

            that.mainContent.fadeTo(100, 1.0);
            that.mainContentOverlay.addClass('hide');

            $('section.feedback').find('a.toggle').css('left', '-30px');

            $(window).unbind('resize');

            window.setTimeout(function() {
                if (that.navShadowElement.is('header')) {
                    that.navShadowElement.removeClass('absolute');
                }

                if (window.yard && window.yard.eventsRequestBox) {
                    window.yard.toggleEventsRequestBox();
                }

                if (that.showCookiePolicyOverlayAfterClosingNow) {
                    window.cookiePolicyOverlayInstance.show();
                    that.showCookiePolicyOverlayAfterClosingNow = false;
                }
            }, 450);
        }

        return false;
    }

    overlayMouseoverHandler() {
        if (this.event.mapOpened) {
            this.event.mainContent.fadeTo(200, 0.5);
            $('div.map-wrapper').addClass('fast-transitions').height(this.event.mapHeight - 10);
            $('div.container').addClass('fast-transitions').css('paddingTop', 55 + this.event.mapHeight - 20);
        }
    }

    overlayMouseoutHandler() {
        if (this.event.mapOpened) {
            this.event.mainContent.fadeTo(200, 0.2);
            $('div.map-wrapper').height(this.event.mapHeight);
            $('div.container').css('paddingTop', 55 + this.event.mapHeight);
        }
    }

    resizeHandler() {
        this.event.mapHeight = $(window).height() - 75;

        $('div.map-wrapper').addClass('fast-transitions').height(this.event.mapHeight);
        $('div.container').addClass('fast-transitions').css('paddingTop', 70 + this.event.mapHeight);
        $("#now-map").height(this.event.mapHeight - 80);
    }

}


// if (this.userId && this.cityId && this.lat && this.lng) {
//     this.initNowMap();
// } else {
//     this.hideNowButton = true;
//     $('#now').css('display', 'none');
// }

export { Map }
